import { render, staticRenderFns } from "./RegionsForm.vue?vue&type=template&id=58f568b6&"
import script from "./RegionsForm.vue?vue&type=script&lang=js&"
export * from "./RegionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports